export const ReportsManagementRoutes = {
    "/reporting": {
        name: "appLayout.reports",
        abstract: true,
        route_dependencies: [
            {
                type: 'chunk',
                loader: () => {
                    return import("./reports-management.module.js");
                }
            },
        ]
    },
    "/employee-docs-detailed-report": {
        name: "appLayout.reports.employee-docs-detailed",
        route_dependencies: [
            {
                type: 'chunk',
                loader: () => {
                    return import("./reports-management.module.js");
                }
            },
        ]
    }
}